/**
 * @generated SignedSource<<e14346509db7226f97e10119c4752de2>>
 * @relayHash 614f48ec7ab3697486d29fc90e8caf36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 31d8bf00d2f6fabcc8c2de42f883aa15c392ccf252cf0470b4e71fb606f51a2b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DashboardsContentViewQuery } from './DashboardsContentViewQuery.graphql';

const node: PreloadableConcreteRequest<DashboardsContentViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "31d8bf00d2f6fabcc8c2de42f883aa15c392ccf252cf0470b4e71fb606f51a2b",
    "metadata": {},
    "name": "DashboardsContentViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
